import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import Flex from '@components/layout/flex';
import Button from '@components/actions/button';
import MotionOpacity from '@components/motion/motion-opacity';
import styled from 'styled-components';

interface ButtonGroupProps {
  className?: string;
  disabled?: boolean;
  customLeftText?: React.ReactNode;
  customRightText?: React.ReactNode;
  alertButton?: boolean;
  onChange: () => void;
  onCancel: () => void;
}

const ButtonGroup: FunctionComponent<ButtonGroupProps> = ({
  className,
  disabled,
  customLeftText,
  customRightText,
  alertButton,
  onChange,
  onCancel,
}) => {
  return (
    <MotionOpacity>
      <Flex
        className={className || ''}
        gap={5}
        alignItems="center"
        style={{ width: '100%' }}
      >
        <Button
          buttonType={alertButton ? 'primary' : 'secondary'}
          onClick={onCancel}
          fullWidth
        >
          {customLeftText ? (
            customLeftText
          ) : (
            <Translate id="BUTTON.GROUP.CANCEL" />
          )}
        </Button>
        <Button
          buttonType={alertButton ? 'alert-secondary' : 'secondary-dark'}
          onClick={onChange}
          fullWidth
          disabled={disabled}
        >
          {customRightText ? (
            customRightText
          ) : (
            <Translate id="BUTTON.GROUP.ADD" />
          )}
        </Button>
      </Flex>
    </MotionOpacity>
  );
};

export default styled(ButtonGroup)`
  flex-direction: column;
  @media ${({ theme }) => theme.device.tablet} {
    flex-direction: row;
  }
`;
